<template>
  <div style="padding: 0 24px 26px 24px ">
    <search-list @findData="findData"></search-list>
    <table-list
      title="" :columns="columns" :data="dataTable"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
    ></table-list>
  </div>
</template>
<script>
  import SearchList from './components/SearchList'
  import TableList from "components/TableList/index";
  import {getBaseHistoryList} from "../../../api/log";
  import {formatDateTime} from '@/utils/format'

  export default {
    name: "log",
    components:{
      SearchList,
      TableList,
    },

    data(){
      return {
        page:1,
        current: 1,
        total: 0,
        dataTable: [],
        loading: false,
        columns:[
          {
            type: "index",
            key: "index",
            width: 60,
            align: "center"
          },
          {title:' '},
          {
            title:'项目名称',
            key:'projectName',
            align:'center',
            width: 150,
          },
          {title:' '},
          {
            title:'房间号',
            key:'houseNumber',
            align:'center',
            width: 150,
          },
          {title:' '},
          {
            title:'修改人',
            key:'createBy',
            align:'center',
            width: 150,
          },
          {title:' '},
          {
            title:'操作人类型',
            key:'operateTypeName',
            align:'center',
            width: 100,
          },
          {title:' '},
          {
            title:'修改价格类型',
            key:'modifyTypeStr',
            align:'center',
            width: 100,
          },
          {title:' '},
          {
            title:'修改前的值',
            key:'oldValue',
            align:'center',
            width: 220,
          },
          {title:' '},
          {
            title:'修改后的值',
            key:'newValue',
            align:'center',
            width: 120,
          },
          {title:' '},
          {
            title:'租期',
            key:'leaseTerm',
            align:'center',
            width: 220,
          },
          {title:' '},
          {
            title:'有效期',
            key:'effectTimeStr',
            align:'center',
            width: 220,
          },
          {title:' '},
          {
            title:'修改时间',
            key:'createTime',
            align:'center',
            width: 180,
            render:(h,params) => {
              return h('span',formatDateTime(params.row.createTime,true))
            }
          },
        ],
        searched:null,
      }

    },
    methods:{
      findData(data){
        this.page=1;
        this.current=1;
        this.getBaseHistoryList(data)
      },
      getBaseHistoryList(data){
        let params={
          ...data,
          page:this.page,
          limit:10
        };
        getBaseHistoryList(params).then(res=>{
          if(!res.data){
            return
          }
          this.dataTable=res.data.rows;
          this.total=res.data.total;
          this.searched=params
        }).catch(error=>{})
      },

      changePage(n){
        this.current = n;
        this.page = n;
        this.getBaseHistoryList(this.searched)
      }

    }
  }
</script>

<style scoped>

</style>
